module.exports = __webpack_public_path__ + "img/排行榜.71b22612.png";